import { Box, Button } from '@mui/material';
import { isEmpty, omitBy } from 'lodash';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

type FilterClearButtonProps = {
  resetFilters?: () => void;
  handleSubmit: () => void;
  handleClose: () => void;
};

export const FilterClearButton = ({ resetFilters, handleSubmit, handleClose }: FilterClearButtonProps) => {
  const { t } = useTranslation(['filters']);
  const { values } = useFormState();
  const filteredValues = omitBy(values, isEmpty);
  const hasActiveFilters = !isEmpty(filteredValues);

  return (
    <Box sx={{ p: 2 }}>
      <Button
        disabled={!resetFilters || !hasActiveFilters}
        onClick={() => {
          if (!resetFilters) return;
          handleSubmit();
          resetFilters();
          handleClose();
        }}
        color="primary"
        variant="contained"
        size="small"
        sx={{ width: '100%' }}
      >
        {t('clear filters')}
      </Button>
    </Box>
  );
};
